import { CdkMenuModule } from "@angular/cdk/menu";
import { CommonModule } from "@angular/common";
import { Injectable, NgModule } from "@angular/core";
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { MatTooltipModule } from "@angular/material/tooltip";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import {
  SedsBasicButtonModule,
  SedsFormFieldDropdownModule,
  SedsLoadersSpinnerModule,
  SedsModalModule,
  SedsSnackbarModule,
  SedsTooltipModule,
} from "@serasa/shared/seds";

import { EmptyListModule } from "@serasa/shared/components/empty-list/empty-list.module";
import { ErrorMessageModule } from "@serasa/shared/components/error-message/error-message.module";
import { MeComponent } from "@serasa/shared/components/me/me.component";
import { NewFeaturesComponent } from '@serasa/shared/components/new-functions/new-features.component';
import { CheckPermissionToDeleteUserDirective } from "@serasa/shared/directives/check-permission-to-delete-user.directive";
import { SharedModule } from "@serasa/shared/shared.module";
import { NotificationsModule } from "../notifications/notifications.module";
import { AddUserComponent } from "./components/add-user/add-user.component";
import { BlockUserComponent } from "./components/block-user/block-user.component";
import { CustomUserModalComponent } from "./components/custom-user-modal/custom-user-modal.component";
import { DeleteUserComponent } from "./components/delete-user/delete-user.component";
import { UserAddSuccessModalComponent } from "./components/user-add-success-modal/user-add-success-modal.component";
import { ErrorLoadUserInfoComponent } from "./components/error-load-user-info/error-load-user-info.component";
import { ErrorLoadingModalComponent } from "./components/error-loading-modal/error-loading-modal.component";
import { ExportButtonComponent } from "./components/export-button/export-button.component";
import { ExportModalComponent } from "./components/export-modal/export-modal.component";
import { ListingComponent } from "./components/listing/listing.component";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { SearchFormModule } from "./components/search-form/search-form.module";
import { SkeletonComponent } from "./components/skeleton/skeleton.component";
import { UnblockUserComponent } from "./components/unblock-user/unblock-user.component";
import { DashboardComponent } from "./dashboard.component";
import { dashboardReducer } from "./state/dashboard.reducer";
import { DashboardEffects } from "./state/effects/dashboard.effect";

@Injectable()
export class MatPaginatorIntlCustom extends MatPaginatorIntl {
  override firstPageLabel = "Primeira página";
  override lastPageLabel = "Última página";
  override itemsPerPageLabel = "";
  override nextPageLabel = "Próxima página";
  override previousPageLabel = "Página anterior";
  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }

    const totalItems = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < totalItems
        ? Math.min(startIndex + pageSize, totalItems)
        : startIndex + pageSize;

    return `${startIndex + 1} - ${endIndex} de ${totalItems}`;
  };
}

@NgModule({  
  declarations: [
    AddUserComponent,
    BlockUserComponent,
    CheckPermissionToDeleteUserDirective,
    CustomUserModalComponent,
    DashboardComponent,
    DeleteUserComponent,
    ErrorLoadUserInfoComponent,
    ErrorLoadingModalComponent,
    ExportButtonComponent,
    ExportModalComponent,
    ListingComponent,
    ResetPasswordComponent,
    SkeletonComponent,
    UnblockUserComponent,
    NewFeaturesComponent,
    UserAddSuccessModalComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    CdkMenuModule,
    CommonModule,
    EffectsModule.forFeature([DashboardEffects]),
    ErrorMessageModule,
    EmptyListModule,
    MatTooltipModule,
    MeComponent,
    NotificationsModule,
    SearchFormModule,
    SedsFormFieldDropdownModule,
    SedsModalModule,
    SedsBasicButtonModule,
    SedsLoadersSpinnerModule,
    SedsTooltipModule,
    SharedModule,
    StoreModule.forFeature("dashboard", dashboardReducer),
    SedsSnackbarModule,
  ],
  exports: [DashboardComponent],
  providers: [
    { provide: MatPaginatorIntl, useClass: MatPaginatorIntlCustom },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        hasBackdrop: true,
        disableClose: true,
      },
    }
  ],
})
export class DashboardModule { }
